import styled from '@emotion/styled';
import { FONT_WEIGHT_NORMAL_PP } from '@/styles';

const Header = styled.div`
  text-align: center;
  padding: 20px 0;
`;

const Container = styled.div``;

const CenteredContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: auto;
  text-align: center;
  font-weight: ${FONT_WEIGHT_NORMAL_PP};
  max-width: 460px;
  margin: 10vh auto 0;
`;

const TitleContainer = styled.div`
  padding: 4px 16px 0;
`;
const Title = styled.h1`
  font-size: 22px;
  line-height: 28px;
  color: #001435;
  height: 28px;
`;

const SubTitle = styled.h2`
  font-size: 18px;
  line-height: 24px;
  color: #545d68;
`;

const IWCPlaceholder = styled.div`
  margin-top: 3vh;
  min-width: 360px;
  min-height: 300px;
`;

const IWCContainer = styled.div`
  padding: 0 20px 10px;
  background-color: #ffffff;
  border-radius: 25px;
`;

const Footer = styled.div`
  text-align: center;
  padding: 30px 0;
`;

export {
  CenteredContainer,
  Container,
  Footer,
  Header,
  IWCContainer,
  IWCPlaceholder,
  SubTitle,
  Title,
  TitleContainer,
};
